import { v4 } from 'uuid'

import { FormItemDraggableBase } from './form-item-draggable-base'
import { IconEnum } from '../../../../../assets/icons'
import { FormItemType } from '../../constants/form-builder.constants'

export const NumberRangeDraggable = () => {
  const id = v4()
  const type = FormItemType.NumberRange

  return (
    <FormItemDraggableBase
      icon={IconEnum.Number}
      id={id}
      title="formBuilder.numberRangeField"
      type={type}
    />
  )
}
